import { render, staticRenderFns } from "./reindex.vue?vue&type=template&id=c6b6d8dc&scoped=true"
import script from "./reindex.vue?vue&type=script&lang=js"
export * from "./reindex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b6d8dc",
  null
  
)

export default component.exports